module.exports = __webpack_public_path__ + "img/browser_tips.a3cc0175.png";